<template>
  <img
    v-if="source"
    :src="source"
    @click="openImage"
    :class="{ clickable: clickable }"
    alt="image"
  />
</template>
<script>

import Utils from '../../utils'

/**
 * @property default Default image (path under assets folder)
 */
export default {
  name: 'VImage',
  props: {
    imageId: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean
    }
  },
  data() {
    return {
      src: ''
    }
  },
  async created() {
    return this.getSrc()
  },
  watch: {
    imageId: function () {
      this.getSrc()
    }
  },
  computed: {
    source() {
      const image = this.$store.getters.image(this.imageId)
      const data = Utils.validBase64SrcString(image)
      if (data == null && this.default) {
        return require('@/assets/' + this.default)
      }
      return data
    }
  },
  methods: {
    async getSrc() {
      if (this.imageId) {
        this.$store.dispatch('fetchImage', this.imageId)
      } else if (this.default) {
        this.src = require('@/assets/' + this.default)
      }
    },
    openImage() {
      if (!this.clickable) {
        return
      }
      const image = new Image()
      image.src = this.source

      const w = window.open('')
      w.document.write(image.outerHTML)
    }
  }
}
</script>
<style scoped lang="scss">
.clickable {
  cursor: pointer;
}
</style>
